import React, { useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'
import { DraftContext } from '../../../../../../contexts/DraftContext'
import { actionTypeLabel } from '../../../../../../utils/actionDisplay'

// Emails are handled by RecipientEmailsSection now - this just picks actions.
export default observer(function RecipientInfluencerGroup({ influencer }) {
  const { actionsForInfluencer, draftState } = useContext(DraftContext)
  const [expanded, setExpanded] = useState(false)
  const infActions = actionsForInfluencer(influencer.id)
  const selectedCount = infActions.filter(a => draftState.isActionSelected(a.id)).length

  const toggleAll = () => {
    const shouldSelect = selectedCount < infActions.length
    infActions.forEach(a => {
      if (shouldSelect !== draftState.isActionSelected(a.id)) draftState.toggleActionSelected(a.id)
    })
  }

  return (
    <div className="mb-1">
      <div className="flex items-center justify-between p-2 bg-gray-50 dark:bg-rb-dark-mode-lighter rounded-lg">
        <div className="flex items-center gap-2">
          <input type="checkbox" checked={infActions.length > 0 && selectedCount === infActions.length} onChange={toggleAll} className="text-rb-green rounded-sm" />
          <span className="text-sm font-bold dark:text-white">{influencer.username}</span>
          <span className="text-xs text-rb-mat-grey dark:text-rb-dark-mode-text-grey">{selectedCount}/{infActions.length}</span>
        </div>
        <button onClick={() => setExpanded(!expanded)}>{expanded ? <ChevronUp /> : <ChevronDown />}</button>
      </div>

      {expanded && (
        <div className="pl-4 pt-2">
          {infActions.map(action => (
            <div key={action.id} className="flex items-center justify-between py-1.5 text-sm dark:text-white">
              <span>{action.name} <span className="text-rb-mat-grey dark:text-rb-dark-mode-text-grey">- {actionTypeLabel(action.action_type)}</span></span>
              <input
                type="checkbox"
                checked={draftState.isActionSelected(action.id)}
                onChange={() => draftState.toggleActionSelected(action.id)}
                className="text-rb-green rounded-sm"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
})
